/* eslint-disable max-lines */
/* eslint-disable camelcase */
import { scrollToElement } from '../helpers/scrollToElement';
import { pushToDataLayer } from '../analytics/pushToDataLayer';

/**
 * Updates the `aria-label` attribute on the menu toggle button.
 */
function setAriaLabelOnMenuToggle () {
  const $button = $('.js-product-filter-toggle');
  let currentState = $button.attr('aria-label');
  let nextState = $button.attr('data-aria-label-toggle');

  $button.attr('aria-label', nextState).attr('data-aria-label-toggle', currentState);
}

/**
 * Toggles filter menu on mobile screens.
 * @param {Object} classObj - class instance
 * @param {Boolean} toggle
 */
export function toggleMobileMenu(classObj, toggle) {
  setAriaLabelOnMenuToggle();

  classObj.isOpen = typeof toggle === 'boolean' ? toggle : !classObj.isOpen;
  $('.js-product-filter-toggle').toggleClass('icon-validation-cross', classObj.isOpen);
  $('.product-filter-toggle-icon').toggleClass('hide', classObj.isOpen);
  $('body').toggleClass('u-overflow-y-hidden', classObj.isOpen);

  if (classObj.isOpen) {
    renderActiveFiltersFromState(classObj.state);
    $('.js-product-filter-apply-count').text(`(${$('.js-product-filter-list-item:not(.hide)').length})`);
  } else {
    scrollToElement($('#product-filter'));
  }

  $('.js-product-filter').toggleClass('product-filter--is-active', classObj.isOpen);
}

/**
 * Display active filter indicator
 * @param {JQuery} $container
 * @param {String} filterLabel - label visible on ui
 * @param {String} filterName - used to populate data-attribute
 */
export function appendActiveFiltersIndication($container, filterLabel, filterName) {
  $container.append(
    `<span
      class="product-filter-single-active js-product-filter-single-active"
      data-filter-name="${String(filterName).toLowerCase()}"
    >${filterLabel}</span>`);
}

/**
 * Counts the number of products in each group and updates product count element.
 * @returns {void}
 */
export function countProductsByGroups() {
  $('.js-product-filter-list').each((index, element) => {
    const $productCountElement = $(element).parents('.js-product-filter-family').find('.js-product-count');
    const numProducts = $(element).find('.js-product-filter-list-item:not(.hide)').length;

    $productCountElement.text(numProducts);
  });
}

/**
 * Shows all products, product families and categories even if some were previously hidden.
 */
export function showAllProducts() {
  $('.js-product-filter-category, .js-product-filter-family, .js-product-filter-list-item')
    .removeClass('hide');
}

/**
 * Resets the state of product filters in the DOM,
 * disabling active filters and clearing their visual indicators.
 *
 * @param {Boolean} forceReset - If true, all filter buttons are enabled.
 * Otherwise, only non-single-select-checkbox filter buttons are enabled.
 */
export function resetFiltersDom(forceReset = false) {
  $('.js-product-filter').removeClass('product-filter--has-applied-filters');
  $('.product-filter-item--is-active').removeClass('product-filter-item--is-active');
  $('.product-filter-item--is-applied').removeClass('product-filter-item--is-applied');
  $('.product-filter-btn--is-active').removeClass('product-filter-btn--is-active');
  $('.js-product-filter-item-active').empty();
  $('.js-product-filter-applied-item').remove();
  $('.js-product-filter-nothing-applied').removeClass('hide');
  $('.js-product-filter-icon')
    .removeClass('icon-arrow-up')
    .addClass('icon-arrow-down');

  if (forceReset) {
    $('.js-product-filter-btn').removeAttr('disabled');
  } else {
    $('.js-product-filter-btn').not('.js-single-select-checkbox').removeAttr('disabled');
  }
}

/**
 * Disable filter checkbox value
 */
export function resetFiltersCheckbox() {
  $('.js-product-filter-btn').prop('checked', false);
}

/**
 * Appends single active filter to the dom.
 * @param {String} groupName - Filter group name
 * @param {Object} filter - Filter object containg label and name
 * @param {JQuery} $filterGroup - Filter group jquery collection
 */
function appendSingleActiveFilter(groupName, filter, $filterGroup) {
  appendActiveFiltersIndication($filterGroup.find('.js-product-filter-item-active'), filter.label.trim(), filter.id);
  $('.js-product-filter-applied-list').append(
    `<div class="product-filter-btn js-product-filter-applied-item" data-filter-group=${groupName}>
      <span>${filter.label}</span>
      <button
        class="product-filter-toggle icon icon-validation-cross u-cursorPointer
          js-product-filter-deactivate-filter"
        data-filter-name="${filter.name}"
      ></button>
    </div>`
  );
}

/**
 * Toggles if the filter should be hidden or not
 * @param {Object} state
 * @param {Object} filter
 * @param {Set} products
 * @returns {Boolean}
 */
function toggleHideFilter(state, filter, products) {
  const productsCount = products.size;
  let hide = productsCount === 0 || productsCount === state.products.size;

  if (productsCount === state.products.size) {
    filter.products.forEach(product => {
      if (products.has(product)) {
        hide = false;
      }
    });
  }

  return hide;
}

/**
 * Hides filters that would if applied give zero results
 * @param {Map} state
 * @param {Object} classObj - class instance
 */
export function hideFiltersWithNoResults(state, classObj) {
  // If no filters are active show all filters, and hide indication for active filter groups
  if (state.activeFilters.length === 0) {
    $('.js-product-filter-accordion-input-and-label').removeClass('pointer-events-none');
    $('.product-filter-item--is-applied').removeClass('product-filter-item--is-applied');

    return;
  }

  classObj.filters.forEach((filterGroup, key) => {
    const $filterGroup = $(`.js-product-filter-item[data-filter-group="${key}"]`);
    // Show all filters that belong to the first applied filter group
    if (state.activeFilters[0].filterGroup === key) {
      $filterGroup.find('.js-product-filter-accordion-input-and-label').removeClass('pointer-events-none');
    } else {
      // Loop through other filter groups
      filterGroup.items.forEach(filter => {
        // Show all active filters from other groups
        if (state.activeFilters.includes(filter)) {
          $filterGroup.find(`.js-product-filter-btn[data-filter-name="${filter.name}"]`).parent().closest('div')
            .removeClass('pointer-events-none');
        } else {
          // Inactive filters from other groups
          const statePlusOne = Object.assign({}, state);
          statePlusOne.activeFilters = [...statePlusOne.activeFilters];
          filter.filterGroup = key;
          statePlusOne.activeFilters.push(filter);
          $filterGroup.find(`.js-product-filter-btn[data-filter-name="${filter.name}"]`).parent().closest('div')
            .toggleClass('pointer-events-none', toggleHideFilter(state, filter, filterProductsArray(statePlusOne, classObj)));
        }
      });
    }
  });
}

/**
 * Update display of the filters from the class instance state
 * @param {Map} state
 */
export function renderActiveFiltersFromState(state) {
  resetFiltersDom();

  //  Remove active state label from all filter groups
  $('.js-product-filter-item').removeClass('product-filter-item--is-applied');
  // Toggle No filters applied label
  $('.js-product-filter-nothing-applied').toggleClass('hide', state.activeFilters.length > 0);

  state.activeFilters.forEach(filter => {
    const { filterGroup } = filter;
    const $filterGroup = $(`.js-product-filter-item[data-filter-group="${filterGroup}"]`);

    appendSingleActiveFilter(filterGroup, filter, $filterGroup);
    $filterGroup.addClass('product-filter-item--is-applied');
    $filterGroup.find(`.js-product-filter-btn[data-filter-name="${filter.name}"]`)
      .addClass('product-filter-btn--is-active');
    $(`#${filter.id}`).prop('checked', true);
  });
  if (state.activeFilters.length) {
    $('.js-product-filter').addClass('product-filter--has-applied-filters');
  }
}

/**
 * Displays the number of products that would be visible after the current filtering is applied.
 * This is done by cloning all products from the dom, and filtering the cloned list.
 * @param {Object} state - ProductFilter class instance state/temp state
 */
export function updateProductCount(state) {
  $('.js-product-filter-apply-count').text(`(${state.products.size})`);
}

/**
 * Gets filter group filters data from DOM
 * @param {JQuery} $filter Filter group
 * @param {String} filterGroupName
 * @returns {Array}
 */
export function getFilterItems($filter, filterGroupName) {
  const items = [];

  $.each($filter.find('.js-product-filter-btn'), (index, item) => {
    const $item = $(item);
    const innerText = $item
      .parents('.js-product-filter-accordion-checkbox-wrapper')
      .find('.product-filter-accordion-label').text().trim();
    const name = $item.data('filter-name').toString().toLowerCase();
    const id = $item.attr('id');
    const label = innerText === '' ? name : innerText;
    const products = [];

    const $productsGroup = $(`.js-product-filter-list-item[data-filter-group-${filterGroupName}`);
    $productsGroup.each((index2, product) => {
      const filterValue = $(product).data(`filter-group-${filterGroupName}`)
        .toString()
        .toLowerCase();

      if (filterValue.length) {
        if (name === filterValue) {
          products.push(product.id);
        } else {
          filterValue.split('|').forEach(splittedValue => {
            if (splittedValue === name) {
              products.push(product.id);
            }
          });
        }
      }
    });

    items.push({ name, label, id, products });
  });

  return items;
}

/**
 * Removes filter from state active filters fields
 * @param {Object} state
 * @param {String} filterName
 */
export function removeActiveFilterFromState(state, filterName) {
  state.activeFilters = state.activeFilters.filter(item => item.name !== filterName);
}

/**
 * Retrieves a list of products matching the specified filter from state
 * @param {Object} filter
 * @param {classObj} classObj - Class instance
 * @returns {Array} products
 */
export function getFilterProducts(filter, classObj) {
  if (typeof filter.name === 'undefined') {
    return [];
  }

  return classObj.filters.get(filter.filterGroup)
    .items.find(filterFromGroup => filterFromGroup.name === filter.name.toString()).products;
}

/**
 * Deep clones state to other state
 * @param {Object} cloneTo - class state that will be reset
 * @param {Object} cloneFrom - class state that will be applied
 */
export function resetState(cloneTo, cloneFrom) {
  cloneTo.activeFilters = JSON.parse(JSON.stringify(cloneFrom.activeFilters));
  cloneTo.products = new Set(cloneFrom.products);
}

/**
 * Filters an array of products based on the active filters in the state object.
 * @param {Object} state - The state object containing the active filters.
 * @param {Object} classObj - The object containing the array of all products and filter functions.
 * @returns {Set} - A set of filtered products.
 */
export function filterProductsArray(state, classObj) {
  if (state.activeFilters.length === 0) {
    return new Set(classObj.allProducts);
  }

  let filterOutcome = new Map();

  state.activeFilters.forEach(filter => {
    const products = new Set(getFilterProducts(filter, classObj));
    const existingProducts = filterOutcome.get(filter.filterGroup) || new Set();

    if (filterOutcome.has(filter.filterGroup)) {
      const filterGroupType = $(`.product-filter-item[data-filter-group="${filter.filterGroup}"]`).attr('data-filter-group-type').toLowerCase();

      if (filterGroupType === 'and') {
        const intersection = new Set([...existingProducts].filter(product => products.has(product)));
        filterOutcome.set(filter.filterGroup, intersection);
      } else {
        const union = new Set([...existingProducts, ...products]);
        filterOutcome.set(filter.filterGroup, union);
      }
    } else {
      filterOutcome.set(filter.filterGroup, products);
    }
  });

  let finalResult = new Set(classObj.allProducts);

  filterOutcome.forEach(products => {
    finalResult = new Set([...finalResult].filter(product => products.has(product)));
  });

  return finalResult;
}

/**
 * Toggles appearance of product families. The family title is visible if there are visible products
 * from that category.
 */
function toggleProductFamilies() {
  $('.js-product-filter-category').each((index, category) => {
    const $category = $(category);
    $category.toggleClass('hide', $category.find('.js-product-filter-list-item:not(.hide)').length === 0);
    $('.js-product-filter-family').each((index2, family) => {
      const $family = $(family);
      $family.toggleClass('hide', $family.find('.js-product-filter-list-item:not(.hide)').length === 0);
    });
  });
}

/**
 * Filter the products on the DOM.
 * @param {Map} state - Filters state from the class instance
 */
export function filterProductsDom(state) {
  showAllProducts();

  let showNoProductsMatch = state.products.size === 0;

  if (state.activeFilters.length > 0) {
    $.each($('.js-product-filter-list-item'), (index, product) => {
      const $product = $(product);
      $product.toggleClass('hide', !state.products.has($product.attr('id')));
    });
  } else {
    $('.js-product-filter-list-item').removeClass('hide');
    showNoProductsMatch = false;
  }

  $('.js-product-filter-no-products-match').toggleClass('hide', !showNoProductsMatch);
  toggleProductFamilies();
}

/**
 * Gets active filters array by reading url params
 * @param {Object} classObj
 * @returns {Array}
 */
export function getActiveFiltersFromUrl(classObj) {
  let activeFiltersSet = new Set();
  const activeFiltersArray = [];
  for (const entry of new URLSearchParams(window.location.search).entries()) {
    const filterGroupFromURL = entry[0];
    const filterGroupItemFromURL = decodeURIComponent(entry[1]);
    const filterGroup = classObj.filters.get(filterGroupFromURL);

    if (filterGroup && filterGroup.items) {
      let filterConfig = filterGroup.items.length ?
        filterGroup.items.find(filter => filter.id === filterGroupItemFromURL) : null;
      if (typeof filterConfig !== 'undefined') {
        const { name, label, id } = filterConfig;
        activeFiltersSet.add(JSON.stringify({ filterGroup: filterGroupFromURL, label, name, id}));
      }
    }
  }

  activeFiltersSet.forEach(filter => activeFiltersArray.push(JSON.parse(filter)));

  return activeFiltersArray;
}

/**
 * Replaces url params from state active filters
 * @param {Object} classObj - class instance
 */
export function updateUrlParamsFromState(classObj) {
  if (!classObj.state.activeFilters.length) {
    history.replaceState(null, null, location.pathname);

    return;
  }

  let searchQuery = '?';
  classObj.state.activeFilters.forEach((filter, index) => {
    searchQuery += `${filter.filterGroup}=${filter.id}${
      classObj.state.activeFilters.length === index + 1 ? '' : '&'}`;
  });

  history.replaceState(null, null, searchQuery);
}

/**
 * Google Analytics
 *
 * Create state gaAppliedFilters object that is manipulated by the filter click, reset and deactivate events.
 * Formated gaAppliedFilters object is pushed to dataLayer.
 */

let gaAppliedFilters = {};

/**
 * Pushes data to the Google Analytics datalayer when a filter is applied.
 * @param {Object} state - The state object containing information about the applied filters.
 */
export function gaDatalayerPush() {
  const formatedAppliedFilters = Object.entries(gaAppliedFilters)
    .map(([groupName, filters]) => `${groupName}[${filters.join(', ')}]`)
    .join(', ');

  if (formatedAppliedFilters) {
    pushToDataLayer({
      event: 'ga4_product_filter',
      ga4_data: {
        action_type: 'Filter applied',
        active_filter_choice: formatedAppliedFilters,
        filter_result_count: window.HMS.ProductFilter.tempState.products.size,
      },
    });
  }
}

/**
 * Updates the filter state by adding or removing a filter from a filter group.
 * If a filter group name is provided, the filter will be added to or removed from that group.
 * If no filter group name is provided, the filter will be removed from any existing group it belongs to.
 * @param {string} filterName - The name of the filter to be added or removed.
 * @param {string|null} filterGroupName - The name of the filter group. If null, the filter will be removed from any group it belongs to.
 */
export function gaUpdateFilterState(filterName, filterGroupName = null) {
  function addToGroup(groupName, name) {
    if (!gaAppliedFilters[groupName]) {
      gaAppliedFilters[groupName] = [];
    }
    gaAppliedFilters[groupName].push(name);
  }

  function removeFromGroup(groupName, name) {
    const index = gaAppliedFilters[groupName].indexOf(name);
    if (index > -1) {
      gaAppliedFilters[groupName].splice(index, 1);
      if (gaAppliedFilters[groupName].length === 0) {
        delete gaAppliedFilters[groupName];
      }
    }
  }

  function removeFilterFromAnyGroup(name) {
    for (const group in gaAppliedFilters) {
      if (gaAppliedFilters.hasOwnProperty(group) && gaAppliedFilters[group].includes(name)) {
        removeFromGroup(group, name);
        break;
      }
    }
  }

  if (filterGroupName) {
    gaAppliedFilters[filterGroupName]?.includes(filterName) ? removeFromGroup(filterGroupName, filterName) : addToGroup(filterGroupName, filterName);
  } else {
    removeFilterFromAnyGroup(filterName);
  }
}

/**
 * Resets the filter state by clearing all applied filters.
 */
export function gaResetFilterState() {
  gaAppliedFilters = {};
}